import { Component, OnInit } from '@angular/core';
import { CommonStoreService } from '../services/common-store.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
})
export class LoginComponent implements OnInit {
  isUserAdmin = false;
  isIntelligenceSuite = false;
  isInventory = false;
  public countriesRefType = 'tred3207';

  constructor(
    private commonStoreService: CommonStoreService
  ) {

  }
  ngOnInit() {
    this.commonStoreService.updateStoreData(this.countriesRefType)
    if (
      window.location.href.indexOf('/admin-ui') >= 0 ||
      window.location.href.indexOf('/studio') >= 0
    ) {
      this.isUserAdmin = true;
    } else if (window.location.href.indexOf('/intelligencesuite-ui') >= 0) {
      this.isIntelligenceSuite = true;
    } else if (window.location.href.indexOf('/inventory-ui') >= 0) {
      this.isInventory = true;
    }
  }
}
